module.exports = __webpack_public_path__ + "static/media/img_3.05680802.png";